export const GET_DOCUMENT_TYPES = 'GET_DOCUMENT_TYPES'
export const GET_DOCUMENT_TYPES_SUCCESS = 'GET_DOCUMENT_TYPES_SUCCESS'

export const GET_DOCUMENT_TYPE_BY_ID = 'GET_DOCUMENT_TYPE_BY_ID'
export const GET_DOCUMENT_TYPE_BY_ID_SUCCESS = 'GET_DOCUMENT_TYPE_BY_ID_SUCCESS'

export const UPDATE_DOCUMENT_TYPE_BY_ID = 'UPDATE_DOCUMENT_TYPE_BY_ID'

export const CREATE_DOCUMENT_TYPE = 'CREATE_DOCUMENT_TYPE'

export const DELETE_DOCUMENT_TYPE_BY_ID = 'DELETE_DOCUMENT_TYPE_BY_ID'
export const DELETE_DOCUMENT_TYPE_BY_ID_SUCCESS =
  'DELETE_DOCUMENT_TYPE_BY_ID_SUCCESS'
